import { __read, __values } from "tslib";
var Executor = /** @class */ (function () {
    function Executor() {
    }
    Executor.addFunction = function (target, param, func) {
        var name = target.constructor;
        if (!Executor.functionMap[name])
            Executor.functionMap[name] = {};
        Executor.functionMap[name][param] = func;
    };
    Executor.execute = function (target) {
        var e_1, _a;
        var name = target.constructor;
        var functionParams = Object.entries(Executor.functionMap[name] || {});
        try {
            for (var functionParams_1 = __values(functionParams), functionParams_1_1 = functionParams_1.next(); !functionParams_1_1.done; functionParams_1_1 = functionParams_1.next()) {
                var _b = __read(functionParams_1_1.value, 2), key = _b[0], func = _b[1];
                var value = target[key];
                delete target[key];
                func(target, value);
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (functionParams_1_1 && !functionParams_1_1.done && (_a = functionParams_1.return)) _a.call(functionParams_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
    };
    Executor.functionMap = {};
    return Executor;
}());
export { Executor };
/**
 * Execute annotation
 *
 * runs the given function when the target is passed in the execute function.
 * after the execution is finished the attribute will be deleted.
 *
 * @param func
 * @constructor
 */
export function Execute(func) {
    return function (target, param) {
        Executor.addFunction(target, param, func);
    };
}
